import React from 'react'
import { Select } from 'antd'

export const statusFilterMethod = (filter, row) => {
  const activeArray = ['Draft', 'Submitted', 'Revised', 'Resubmitted']
  const closedArray = [
    'Lost',
    'Declined',
    'Cancelled',
    'Closed (Awarded)',
    'Closed (Declined)',
    'Closed (Lost)',
    'Closed (Cancelled)',
  ]
  if (filter.value === 'all') {
    return true
  }
  if (filter.value === 'approved') {
    return row[filter.id] === 'Approved'
  }
  if (filter.value === 'draft') {
    return row[filter.id] === 'Draft'
  }
  if (filter.value === 'submitted') {
    return row[filter.id] === 'Submitted'
  }
  if (filter.value === 'revised') {
    return row[filter.id] === 'Revised'
  }
  if (filter.value === 'resubmitted') {
    return row[filter.id] === 'Resubmitted'
  }
  if (filter.value === 'cancelled') {
    return row[filter.id] === 'Cancelled'
  }
  if (filter.value === 'rejected') {
    return row[filter.id] === 'Rejected'
  }

  return filter.value === 'active' ? activeArray.includes(row[filter.id]) : closedArray.includes(row[filter.id])
}

function StatusFilter({ onChange, filter }) {
  return (
    <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
      <Select.Option value={'active'}>Not Yet Approved</Select.Option>
      <Select.Option value={'approved'}>Approved</Select.Option>
      <Select.Option value={'draft'}>Draft</Select.Option>
      <Select.Option value={'submitted'}>Submitted</Select.Option>
      <Select.Option value={'revised'}>Revised</Select.Option>
      <Select.Option value={'resubmitted'}>Resubmitted</Select.Option>
      <Select.Option value={'cancelled'}>Cancelled</Select.Option>
      <Select.Option value={'rejected'}>Rejected</Select.Option>
      <Select.Option value={'all'}>All</Select.Option>
    </Select>
  )
}

StatusFilter.propTypes = {}
StatusFilter.defaultProps = {}

export default StatusFilter
